export default __webpack_public_path__ + "static/Galdeano-Regular-34db40ceb0a46a1a687fbd7325415063.ttf";